import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import ExternalLinkButton from 'components/external-link-button'
import RouterLinkButton from 'components/router-link-button'
import SocialShareDialog from 'components/social-share-dialog'
import VisibilityOutlinedIcon from 'components/material-symbol/icons/Visibility'
import EditOutlinedIcon from 'components/material-symbol/icons/Edit'
import LinkIcon from 'components/material-symbol/icons/Link'
import { PGA_COM_HOST } from 'env'
import { useIsMobile, useIsTablet } from 'lib/hooks'

const ProfileActions = ({ customSlug, className }) => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const shareUrl = `${PGA_COM_HOST}/coach/${customSlug}`

  if (!customSlug) {
    return null
  }

  if (isTablet || isMobile) {
    return (
      <Box display="flex" className={className}>
        <IconButton
          color="primary"
          href={`${PGA_COM_HOST}/coach/${customSlug}`}
        >
          <VisibilityOutlinedIcon />
        </IconButton>

        <SocialShareDialog
          trigger={
            <IconButton color="primary">
              <LinkIcon fontSize="small" />
            </IconButton>
          }
          shareUrl={shareUrl}
          shareTitle="Coach Profile"
          dialogTitle="Share your coach profile"
          dialogSubtitle="Share the link to your public Coach Profile with your students"
          showBookingUrl
          att="coach-profile-link"
        />

        <IconButton
          color="primary"
          href="/pga-coach/profile/edit"
          data-cy="edit-profile-link"
        >
          <EditOutlinedIcon />
        </IconButton>
      </Box>
    )
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      className={className}
    >
      <ExternalLinkButton
        variant="outlined"
        color="primary"
        startIcon={<VisibilityOutlinedIcon fontSize="small" />}
        href={`${PGA_COM_HOST}/coach/${customSlug}`}
      >
        View
      </ExternalLinkButton>
      <SocialShareDialog
        trigger={
          <Button
            variant="outlined"
            color="primary"
            startIcon={<LinkIcon fontSize="small" />}
          >
            Share
          </Button>
        }
        shareUrl={shareUrl}
        shareTitle="Coach Profile"
        dialogTitle="Share your coach profile"
        dialogSubtitle="Share the link to your public Coach Profile with your students"
        showBookingUrl
        att="coach-profile-link"
      />
      <RouterLinkButton
        variant="outlined"
        color="primary"
        to="/pga-coach/profile/edit"
        startIcon={<EditOutlinedIcon fontSize="small" />}
        data-cy="edit-profile-link"
      >
        Edit
      </RouterLinkButton>
    </Box>
  )
}

export default ProfileActions
